module.exports = __webpack_public_path__ + "img/20200609_132529.6e2ddd1b.jpg";